export default "__VITE_ASSET__b5ecb94e__"